// extracted by css-extract-rspack-plugin
export default {"icon":"header-fragment__ActionHeader_icon__WlqDM"};